module.exports = __webpack_public_path__ + "static/media/banner-marron.1fd68621.png";